const type = 'SET_RECHARGE_AMOUNT_INPUT';

const setRechargeAmountInput = (data) => ({
  data,
  type,
});

export { type };
export default setRechargeAmountInput;
